import type { ExportImageOptions } from "@/core/export-image"

export const defaultPreviewOptions: ExportImageOptions = {
	resizeWidth: 1024,
	resizeHeight: 1024,
	resizeMode: "fit",
	type: "jpg",
	quality: 0.7,
	filenameType: "original",
	format: "yuv",
}
